import type { MarkOptional, OmitProperties } from 'ts-essentials'
import { Timestamp } from 'firebase/firestore'

export type TemplateCategoryParams = OmitProperties<MarkOptional<TemplateCategory, 'createdAt' | 'updatedAt'>, Function>

export class TemplateCategory {
  id?: string
  name: string
  order: number
  published: boolean
  type: 'video' | 'image' = 'image'

  createdAt: Date
  updatedAt: Date

  static toFirestore(templateCategory: TemplateCategory) {
    return {
      name: templateCategory.name,
      order: templateCategory.order,
      published: templateCategory.published,
      type: templateCategory.type,
      id: templateCategory.id,
      createdAt: Timestamp.fromDate(templateCategory.createdAt),
      updatedAt: Timestamp.fromDate(templateCategory.updatedAt),
    }
  }

  static fromFirestore(snapshot: any): TemplateCategory {
    const data = snapshot.data()

    return new TemplateCategory({
      name: data.name,
      order: data.order,
      published: data.published,
      type: data.type,
      id: snapshot.id,
      createdAt: data.createdAt ? data.createdAt.toDate() : new Date(),
      updatedAt: data.updatedAt ? data.updatedAt.toDate() : new Date(),
    })
  }

  constructor(params?: TemplateCategoryParams) {
    this.id = params?.id
    this.name = params?.name || 'Untitled Category'
    this.order = params?.order || 0
    this.published = params?.published || false
    this.type = params?.type || 'image'

    this.createdAt = params?.createdAt || new Date()
    this.updatedAt = params?.updatedAt || new Date()
  }

  toJSON(): TemplateCategoryParams {
    return {
      id: this.id,
      name: this.name,
      type: this.type,
      order: this.order,
      published: this.published,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
    }
  }
}
